import { forwardRef } from "react";

import CloseIcon from "@mui/icons-material/Close";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { Box, SvgIcon, Typography } from "@mui/material";

import { AssistantBookIcon } from "../../assets";
import { ASSISTANT_NAME } from "../../constants";
import { AssistantMutedText } from "../../styles";
import {
  AssistantAvatar,
  AssistantCloseButton,
  AssistantHeader,
  AssistantMoveButton,
  AssistantResizeButton,
  StyledAssistantPanel,
  StyledAssistantPanelResizeIcon,
} from "./styles";
import { IAssistantPanelProps } from "./types";

const AssistantPanel = forwardRef<HTMLDivElement, IAssistantPanelProps>(
  function AssistantPanel(
    {
      children,
      onClose,
      panelPosition,
      dragHandlers,
      dragging,
      panelSize,
      resizeHandlers,
    },
    ref
  ) {
    return (
      <StyledAssistantPanel
        ref={ref}
        panelPosition={panelPosition}
        panelSize={panelSize}
        role="region"
        aria-label={`${ASSISTANT_NAME} chat`}
      >
        <AssistantHeader {...dragHandlers} dragging={dragging}>
          <AssistantMoveButton
            {...dragHandlers}
            variant="text"
            fullWidth={false}
            aria-label={`Move ${ASSISTANT_NAME} chat. Use arrow keys to move`}
            title="Drag to move, or focus and use arrow keys"
          >
            <DragIndicatorIcon fontSize="small" />
          </AssistantMoveButton>
          <AssistantAvatar>
            <SvgIcon
              component={AssistantBookIcon}
              inheritViewBox
              fontSize="small"
            />
          </AssistantAvatar>
          <Box>
            <Typography variant="h3" component="h2">
              {ASSISTANT_NAME}
            </Typography>
            <AssistantMutedText variant="subtitle9">
              GD Dashboard guides
            </AssistantMutedText>
          </Box>
          <AssistantCloseButton
            variant="text"
            fullWidth={false}
            aria-label={`Close ${ASSISTANT_NAME} chat`}
            onClick={onClose}
          >
            <CloseIcon fontSize="small" />
          </AssistantCloseButton>
        </AssistantHeader>
        {children}
        <AssistantResizeButton
          {...resizeHandlers}
          variant="text"
          fullWidth={false}
          aria-label={`Resize ${ASSISTANT_NAME} chat`}
          title="Drag to resize. Arrow Left or Up enlarges; Right or Down shrinks."
        >
          <StyledAssistantPanelResizeIcon fontSize="inherit" />
        </AssistantResizeButton>
      </StyledAssistantPanel>
    );
  }
);

export default AssistantPanel;
